import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import PALETTE_SCHEMA from './account.palette-schema.yaml';

class AccountFeature extends AbstractVisualFeature {
    get name() {
        return 'Account';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }
}
export const Account = new AccountFeature(allVisuals);
